<template>
  <div class="newMedia">
    <DetailsNav></DetailsNav>
    <div class="banner">
        <div class="banerCont" v-if="bannerInfo" :style="{'background-color': bannerInfo.bannerColor, 'background-image': `url(${bannerInfo.bannerBgImg})`}">
            <div class="cont">
                <div class="leftCont">
                    <div class="logo" v-if="bannerInfo.logo && bannerInfo.logo.length > 0"><img :src="bannerInfo.logo[0].url" height="121px" alt=""></div>
                    <div v-else>
                        <div class="title"><div class="colFont">{{bannerInfo.objectName}}</div></div>
                        <div class="subTitle"><div class="colFont">{{bannerInfo.objectSubtitle}}</div></div>    
                    </div>
                    <div class="desc">
                        <banner-desc :data="strToArr(bannerInfo.objectIntroduction)"></banner-desc>
                    </div>
                </div>
                <div class="rightCont">
                    <div class="subjectflowTitle">
                        <div class="divNav">
                            <span @click="() => {$router.push('/')}" class="spanSubject">首页 / </span>
                            <span @click="() => {$router.push('/nm')}" class="spanSubject">新媒体主页</span>
                            <span class="spanSplit"> / </span>
                            <span class="spanName">{{ bannerInfo.objectName }}</span>
                        </div>
                    </div>
                    <div class="videoBox">
                        <div class="videoMain">
                            <div class="actLab"><span></span><span></span><span></span></div>
                            <div v-if="videoUrl" class="play"  @click="handleVideo()">
                                <img src="./img/icon_play_real.png" width="45px" height="45px" alt="">
                                <div class="videoDesc">
                                    {{videoDesc}}
                                </div>
                            </div>
                            <img v-if="bannerInfo.videoBackground && bannerInfo.videoBackground.length > 0" width="574" :src="bannerInfo.videoBackground[0].url" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bannerLablsit" v-if="bannerLablsit.length > 0">
      <div class="item" v-for="(item, index) in bannerLablsit" :key="index">
        <img v-if="item.icon" :src="item.icon[0].url" alt="">
        <div>{{item.lab}}</div>
        <span>{{item.num}}</span>
      </div>
    </div>
    <div id="scrollA" class="studentsWork" v-if="studentWorksMinModule && studentWorksMinModule.StudentWorksTitle">
      <modelTitl :title="studentWorksMinModule.StudentWorksTitle" :enTag="studentWorksMinModule.StudentWorksEnTitle"></modelTitl>
      <div class="content" >
        <div class="itemCont">
          <div class="studentWorksLeft" @click="lookBigImage(studentWorksLeft)">
            <div class="imgCont">
              <div class="labal">{{studentWorksLeft.labName}}</div>
              <div class="stImg" :style="`background-image:url(${studentWorksLeft.image[0].url})`"></div>
            </div>
            <div class="infoCont">
              <div class="titCont">
                <div class="tit">{{studentWorksLeft.title}}</div>
                <div class="des">{{studentWorksLeft.subTitle}}</div>
              </div>
              <div class="info">
                  <div class="labItems" v-for="(item, index) in studentWorksLeft.labTree" :key="index">
                    <div class="tit">{{item.subTitle}}<span>{{item.desc}}</span></div>
                    <div class="des">{{item.title}}</div>
                  </div>
              </div>
            </div>
          </div>
          <div class="studentWorksRit">
            <div :class="{rollCont: true, roll:studentWorksRit && studentWorksRit.length > 2}">
              <div class="items" v-for="(item, index) in studentWorksRit" :key="index" @click="lookBigImage(item)">
                  <div class="imgCont">
                    <div class="labal">{{item.labName}}</div>
                    <div class="stImg" :style="`background-image:url(${item.image[0].url})`"></div>
                  </div>
                  <div class="titCont">
                    <div class="tit">{{item.title}}</div>
                    <div class="des">{{item.subTitle}}</div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :id="`scrollB` + (index+1)" :class="`pubModule pubModule${index != 0 ? '1': '' }`"  v-for="(item, index) in pubModulesData" :key="index" :style="`background-color:${item.bgColor ? item.bgColor : '#fff'};background-image:url(${item.bgImage.length > 0 ? item.bgImage[0].url : ''});}`">
        <modelTitl :title="item.title" :enTag="item.EnTitle"></modelTitl>
        <div class="contents" v-if="index == 0" :class="{scrollBShow: scrollBShow}">
            <img :src="item.image[0].url" width="100%" alt="">
        </div>
        <div class="contents" v-if="index == 1" :class="{scrollB1Show: scrollB1Show}">
            <img :src="item.image[0].url" width="100%" alt="">
        </div>
    </div>
    <div id="scrollC" class="abilityModular" v-if="abilityModular != null">
      <modelTitl :title="abilityModular.title" :enTag="abilityModular.EnTitle"></modelTitl>
      <div class="cantents" :class="{scrollCShow: scrollCShow}">
        <div class="items">
          <div class="item" v-for="(item, index) in abilityModular.listData" :key="index">
            <div><img :src="item.image[0].url" width="66px" alt=""></div>
            <div>{{item.title}}</div>
          </div>
        </div>
      </div>
    </div>
    <div id="scrollD" class="classModular" :style="`background-color:${classModular.bgColor ? classModular.bgColor : '#fff'};background-image:url(${classModular.bgImage.length > 0 ? classModular.bgImage[0].url : ''});}`">
      <div class="bgDefault" v-if="classModular.bgImage.length <= 0"></div>
      <modelTitl :title="classModular.title" :enTag="classModular.EnTitle"></modelTitl>
      <div class="cantents" :class="{scrollDShow: scrollDShow}">
        <div class="listCont">
            <div class="titleCont">
              <div class="item" v-for="(item,index) in classModular.listData" :key="index">
                <div class="tit">
                  <img :src="item.image[0].url" width="46px" height="46px" alt="">
                  <div>{{item.title}}</div>
                </div>
              </div>
            </div>
            <div class="itemCont">
                <div class="item" v-for="(item,index) in classModular.listData" :key="index">
                  <div class="cont">
                    <div :class="{rollBox: true, roll:item.about && item.about.split(/\r|\n|\r\n/).length > 10}">
                      <div v-for="(it, ind) in item.about.split(/\r|\n|\r\n/)" :key="ind">{{cutstr(it, 50)}}</div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="biggerImgPreview"
      :before-close="closeImg"
      :close="closeImg"
      class="bigImgDialog"
      style="margin-top: 3vh"
      append-to-body
    >
      <div class="DesClose" @click="closeImg">
        <img src="./img/close _1.png" width="28px" alt="" />
      </div>
      <div style="overflow: hidden">
        <div style="overflow-y: scroll; height: 93vh">
          <img v-if="showBigImageUrl" :src="showBigImageUrl" width="100%" />
        </div>
      </div>
    </el-dialog>
    <bottom-widge></bottom-widge>
    <MenuAdd ref="editMenu"></MenuAdd>
    <RiskWarning ref="RiskWarning" :url="goUrl"></RiskWarning>
  </div>
</template>
<script>
import { newMedia } from "../../../../gqlapi/newMedia.js";
import DetailsNav from "./../../../components/detailsNav.vue";
import bannerDesc from "./../../../components/bannerDesc.vue";
import modelTitl from "./components/modelTitle.vue"
import bottomWidge from "./../../../components/bottomWidge";
import MenuAdd from "./../../../components/video";
import { CutString } from './../../../../utils/tools'
import RiskWarning from "../../../components/riskWarning.vue";
export default {
  components: {
    bannerDesc,
    DetailsNav,
    bottomWidge,
    modelTitl,
    MenuAdd,
    RiskWarning
  },
  data() {
    return {
        bannerInfo: null,
        classData: null, // 课程大纲
        videoDesc: '了解项目特色',
        bannerLablsit: [],
        studentWorksMinModule: null,
        studentWorksLeft:[],
        studentWorksRit:[],
        pubModulesData:[],
        abilityModular:null,
        classModular: null,
        scrollAShow:false,
        scrollBShow:false,
        scrollB1Show:false,
        scrollCShow:false,
        scrollDShow:false,
        biggerImgPreview:false,
        showBigImageUrl: '',
        goUrl: ''
    };
  },
  created() {
    this.getData();
    window.addEventListener("scroll", this.scrollMoveHandle);
  },
  methods: {
      getData() {
        this.$axios.post('/api',{
            operationName: "newMedia",
            variables:{
              id: sessionStorage.getItem("detailsId"),
            },
            query: newMedia
        })
        .then((res) => {
          const data = this.baseData = res.data.data.newMedia
          this.bannerInfo = {
              logo:data.logo,
              objectName:data.ObjectName,
              objectSubtitle:data.objectSubtitle,
              objectIntroduction:data.objectIntroduction,
              bannerColor:data.bannerColor,
              videoBackground:data.videoBackground,
              videoDesc:data.videoDesc,
              bannerBgImg: data.bannerImg && data.bannerImg.length > 0 ? data.bannerImg[0].url : ''
          }
          this.videoUrl = data.videoUrl
          this.classData = data.classList
          this.videoDesc = data.videoDesc
          this.bannerLablsit = data.bannerBotLab
          this.studentWorksMinModule = {
            StudentWorksTitle:data.StudentWorksTitle,
            StudentWorksEnTitle:data.StudentWorksEnTitle,
            StudentWorksBgColor:data.StudentWorksBgColor,
            bgImg:data.bgImg && data.bgImg.length > 0 ? data.bgImg[0].url : '' 
          }
          this.studentWorksLeft = data.studentWorks[0]
          this.studentWorksRit = data.studentWorks && data.studentWorks.length > 0 ? data.studentWorks.slice(1,data.studentWorks.length):[]
          this.pubModulesData = data.publicModule,
          this.abilityModular = {
            title: data.abilityTitle,
            EnTitle: data.abilityEntitle,
            listData: data.abilityLists
          }
          this.classModular = {
            bgColor: data.classBgColor ? data.classBgColor : '#fff',
            bgImage: data.classBgImg,
            title: data.classTitle,
            EnTitle: data.classEntitle,
            listData: data.classLists
          }
        });
    },
    scrollMoveHandle() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 显示马上学习导航
      let tag2 = document.querySelector("#scrollA");
      let tag3 = document.querySelector("#scrollB1");
      let tag31 = document.querySelector("#scrollB2");
      let tag4 = document.querySelector("#scrollC");
      let tag5 = document.querySelector("#scrollD");
      const num = 650
      if (scrollTop >= tag2.offsetTop - num) {
        this.scrollAShow = true;
      }
      if (scrollTop >= tag3.offsetTop - num) {
        this.scrollBShow = true;
      }
      if (scrollTop >= tag31.offsetTop - num) {
        this.scrollB1Show = true;
      }
      if (scrollTop >= tag4.offsetTop - num) {
        this.scrollCShow = true;
      }
      if (scrollTop >= tag5.offsetTop - num) {
        this.scrollDShow = true;
      }
    },
    cutstr(str, ind){
      return CutString(str, ind)
    },
    // 
    goDetailPage(url){
      if (url && /^http/.test(url)){
          //     window.open(url, '_black')
          this.goUrl = url
          this.$refs.RiskWarning.dialogFormV()
      }
    },
    // 点击体验弹窗
    openActionHandle(){
        this.showActionPop = true
    },
    closeTopImg(){
        window.localStorage.setItem('topImgSt','unShow')
        this.topImgSt = false
    },
    lookBigImage(item) {
      if (item.url){
        if(/.mp4$/.test(item.url)){
          let obj = {
            url: item.url,
          };
          this.$refs.editMenu.dialogFormV(obj);
        } else {
          this.goDetailPage(item.url)
        }
      } else if (item.imgUrl && item.imgUrl.length > 0){
        this.biggerImgPreview = true;
        this.showBigImageUrl = item.imgUrl[0].url;
      }
    },
    closeImg() {
      this.biggerImgPreview = false;
      this.showBigImageUrl = "";
    },
    handleVideo() {
      this.$trackEvent("视频介绍", "点击", "新媒体学科");
      let obj = {
        url: this.videoUrl,
      };
      this.$refs.editMenu.dialogFormV(obj);
    }
  },
};
</script>
<style lang="scss" scoped src="./index.scss"></style>>
<style>
.bigImgDialog .el-dialog {
  width: 80% !important;
  max-width: 1180px;
}
.DesClose {
  cursor: pointer;
  position: absolute;
  top: 0px;
  right: -54px;
}
.el-dialog__body {
  position: relative;
}
</style>